import { osnSignOutIcon } from './icons/sign-out';
import { osnCaretDownIcon } from './icons/CaretDown';
import { osnProfileIcon } from './icons/Profile';
import { osnMoveToTopIcon } from './icons/MoveToTop';
import { osnAmexIcon } from './icons/AMEX';
import { osnArabicIcon } from './icons/Arabic';
import { osnArrowLeftIcon } from './icons/Arrow-left';
import { osnArrowRightIcon } from './icons/Arrow-right';
import { osnArrowPlayerLeftIcon } from './icons/Arrow_player_left';
import { osnArrowPlayerRightIcon } from './icons/Arrow_player_right';
import { osnBack50Icon } from './icons/Back50';
import { osnCancelIcon } from './icons/Cancel';
import { osnCardTemplateIcon } from './icons/Card-template';
import { osnCardTypeIcon } from './icons/Card-type';
import { osnCastIcon } from './icons/Cast';
import { osnCheckIcon } from './icons/Check';
import { osnCloneIcon } from './icons/Clone';
import { osnDiscoverIcon } from './icons/Discover';
import { osnDownIcon } from './icons/Down';
import { osnDownBoldIcon } from './icons/Down-bold';
import { osnDragDropIcon } from './icons/DragDrop';
import { osnEditIcon } from './icons/Edit';
import { osnEmailIcon } from './icons/Email';
import { osnEnIcon } from './icons/EN';
import { osnEpisodesIcon } from './icons/Episodes';
import { osnEyeIcon } from './icons/Eye';
import { osnEyeClosedIcon } from './icons/EyeClosed';
import { osnFaceDeadIcon } from './icons/Face_dead';
import { osnFacebookIcon } from './icons/Facebook';
import { osnForwardIcon } from './icons/Forward';
import { osnFullscreenIcon } from './icons/Fullscreen';
import { osnFullscreenQuitIcon } from './icons/Fullscreen-quit';
import { osnFw45Icon } from './icons/Fw45';
import { osnGeolockIconIcon } from './icons/GeolockIcon';
import { osnHamburgerCloseIcon } from './icons/Hamburger_close';
import { osnHamburgerMenuIcon } from './icons/Hamburger_menu';
import { osnInstaIcon } from './icons/Insta';
import { osnKebabIcon } from './icons/Kebab';
import { osnLeftIcon } from './icons/Left';
import { osnLeftBoldIcon } from './icons/Left-bold';
import { osnMastercardIcon } from './icons/Mastercard';
import { osnMoreInfoIcon } from './icons/More_info';
import { osnNextIcon } from './icons/Next';
import { osnNoFoundIcon } from './icons/No_found';
import { osnPauseIcon } from './icons/Pause';
import { osnPlayIcon } from './icons/Play';
import { osnPlusIcon } from './icons/Plus';
import { osnPlusBoldIcon } from './icons/Plus-bold';
import { osnPlusInCircleIcon } from './icons/Plus-in-circle';
import { osnPlusInCircleBoldIcon } from './icons/Plus-in-circle-bold';
import { osnPreviousIcon } from './icons/Previous';
import { osnReorderIcon } from './icons/Reorder';
import { osnRewindIcon } from './icons/Rewind';
import { osnRightIcon } from './icons/Right';
import { osnRightBoldIcon } from './icons/Right-bold';
import { osnSearchIcon } from './icons/Search';
import { osnSettingsIcon } from './icons/Settings';
import { osnSubtitleIcon } from './icons/Subtitle';
import { osnTickIcon } from './icons/Tick';
import { osnTickmarkInCircleIcon } from './icons/Tickmark-in-circle';
import { osnTiktokIcon } from './icons/Tiktok';
import { osnTrailerIcon } from './icons/Trailer';
import { osnTrashIcon } from './icons/Trash';
import { osnTwitterIcon } from './icons/Twitter';
import { osnUpIcon } from './icons/Up';
import { osnUpBoldIcon } from './icons/Up-bold';
import { osnUploadIcon } from './icons/Upload';
import { osnVisaIcon } from './icons/Visa';
import { osnVolumeIcon } from './icons/Volume';
import { osnVolumeMutedIcon } from './icons/VolumeMuted';
import { osnWarningIcon } from './icons/Warning';
import { osnYoutubeIcon } from './icons/Youtube';
import { osnCalendarIcon } from './icons/Calendar';
import { osnImageDeleteTrashIcon } from './icons/ImageDeleteTrash';
import { osnBackAndForthArrowsIcon } from './icons/back-and-forth-arrows';
import { osn4KIcon } from './icons/4k';
import { osnArrowRightSmallIcon } from './icons/Arrow-right-small';
import { osnContinueWatchingPlayIconIcon } from './icons/Continue_watching_play_icon';
import { osnDolbyAtmosIcon } from './icons/DolbyAtmos';
import { osnDoNotEnterIcon } from './icons/DoNotEnter';
import { osnExclamationInCircleIcon } from './icons/Exclamation-in-circle';
import { osnForwardEmptyIcon } from './icons/Forward-empty';
import { osnGridViewIcon } from './icons/Grid_view';
import { osnListViewIcon } from './icons/List_view';
import { osnMoreInfoNoCircleIcon } from './icons/MoreInfoNoCircle';
import { osnOsnPlusIcon } from './icons/OsnPlus';
import { osnPlayIndicatorIcon } from './icons/Play_indicator';
import { osnPlayerStartOverIcon } from './icons/Player-start-over';
import { osnPlusInCircleFilledIcon } from './icons/Plus-in-circle-filled';
import { osnPlus16Icon } from './icons/Plus16';
import { osnRewindEmptyIcon } from './icons/Rewind-empty';
import { osnStartOverIcon } from './icons/Start-over';
import { osnTick32Icon } from './icons/Tick32';
import { osnTickmarkInCircleFilledIcon } from './icons/Tickmark-in-circle-filled';
import { osnTop1010SIcon } from './icons/Top10_10S';
import { osnTop101SIcon } from './icons/Top10_1S';
import { osnTop102SIcon } from './icons/Top10_2S';
import { osnTop103SIcon } from './icons/Top10_3S';
import { osnTop104SIcon } from './icons/Top10_4S';
import { osnTop105SIcon } from './icons/Top10_5S';
import { osnTop106SIcon } from './icons/Top10_6S';
import { osnTop107SIcon } from './icons/Top10_7S';
import { osnTop108SIcon } from './icons/Top10_8S';
import { osnTop109SIcon } from './icons/Top10_9S';
import { osnMoreInfoCircleIcon } from './icons/More_info_circle';
import { osnPlusRefresh } from './icons/Refresh';
import { osnSignalIcon } from './icons/Signal';

export const iconComponents = [
  osnAmexIcon,
  osnArabicIcon,
  osnArrowLeftIcon,
  osnArrowPlayerLeftIcon,
  osnArrowPlayerRightIcon,
  osnArrowRightIcon,
  osnBack50Icon,
  osnCardTemplateIcon,
  osnCancelIcon,
  osnCastIcon,
  osnCheckIcon,
  osnCloneIcon,
  osnDiscoverIcon,
  osnDownIcon,
  osnDragDropIcon,
  osnEditIcon,
  osnEnIcon,
  osnEpisodesIcon,
  osnEyeIcon,
  osnEyeClosedIcon,
  osnFaceDeadIcon,
  osnFacebookIcon,
  osnForwardIcon,
  osnFullscreenQuitIcon,
  osnFullscreenIcon,
  osnFw45Icon,
  osnGeolockIconIcon,
  osnHamburgerCloseIcon,
  osnHamburgerMenuIcon,
  osnInstaIcon,
  osnKebabIcon,
  osnLeftIcon,
  osnMastercardIcon,
  osnMoreInfoIcon,
  osnNextIcon,
  osnNoFoundIcon,
  osnPauseIcon,
  osnPlayIcon,
  osnPlusInCircleIcon,
  osnPlusIcon,
  osnPreviousIcon,
  osnReorderIcon,
  osnRewindIcon,
  osnRightIcon,
  osnSearchIcon,
  osnSettingsIcon,
  osnSubtitleIcon,
  osnTiktokIcon,
  osnTrailerIcon,
  osnTrashIcon,
  osnTwitterIcon,
  osnUpIcon,
  osnUploadIcon,
  osnVisaIcon,
  osnVolumeIcon,
  osnVolumeMutedIcon,
  osnWarningIcon,
  osnYoutubeIcon,
  osnPlusBoldIcon,
  osnPlusInCircleBoldIcon,
  osnDownBoldIcon,
  osnUpBoldIcon,
  osnRightBoldIcon,
  osnLeftBoldIcon,
  osnEmailIcon,
  osnTickmarkInCircleIcon,
  osnCardTemplateIcon,
  osnCardTypeIcon,
  osnTickIcon,
  osnCalendarIcon,
  osnMoveToTopIcon,
  osnImageDeleteTrashIcon,
  osnProfileIcon,
  osnCaretDownIcon,
  osnBackAndForthArrowsIcon,
  osnSignOutIcon,
  osnForwardEmptyIcon,
  osnRewindEmptyIcon,
  osnPlusInCircleFilledIcon,
  osnTickmarkInCircleFilledIcon,
  osnTick32Icon,
  osn4KIcon,
  osnDolbyAtmosIcon,
  osnMoreInfoNoCircleIcon,
  osnOsnPlusIcon,
  osnStartOverIcon,
  osnPlayerStartOverIcon,
  osnListViewIcon,
  osnGridViewIcon,
  osnExclamationInCircleIcon,
  osnPlus16Icon,
  osnTop101SIcon,
  osnTop102SIcon,
  osnTop103SIcon,
  osnTop104SIcon,
  osnTop105SIcon,
  osnTop106SIcon,
  osnTop107SIcon,
  osnTop108SIcon,
  osnTop109SIcon,
  osnTop1010SIcon,
  osnArrowRightSmallIcon,
  osnContinueWatchingPlayIconIcon,
  osnPlayIndicatorIcon,
  osnDoNotEnterIcon,
  osnMoreInfoCircleIcon,
  osnPlusRefresh,
  osnSignalIcon,
];
